import * as R from 'ramda'
import { of } from 'rxjs'
import {
  delayWhen,
  distinctUntilChanged,
  filter,
  ignoreElements,
  tap
} from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import facebookPixel from 'tracking/facebookPixel'
import * as Actions from 'store/actions/index.ts'
import { isSaleHomePageAction } from 'domain/router'
import {
  getOperationCode,
  getOperationId,
  getSaleResource
} from 'store/selectors'
import { disableFacebookTracking } from '../disable'

export const mapStateToFPEvent = (state) => ({
  operation_code: getOperationCode(state),
  operation_ID: getOperationId(state)
})

const viewContentSaleHomeEpic = (actions$, state$) => actions$.pipe(
  disableFacebookTracking(actions$),
  ofType(LOCATION_CHANGE),
  distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname']))),
  filter(isSaleHomePageAction),
  delayWhen(() => (getSaleResource(state$.value))
    ? of({})
    : actions$.pipe(
      ofType(Actions.resources.RESOURCE_FETCHED),
      filter(({ payload: { type } }) => (type === 'sale'))
    )
  ),
  tap(() => {
    facebookPixel.trackCustom('ViewSaleHome', mapStateToFPEvent(state$.value))
  }),
  ignoreElements()
)

export default viewContentSaleHomeEpic
